// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"25f45336","322":"95c568fc","364":"60b06bed","534":"61de2c7c","685":"d6ed2c94"}[chunkId] + ".css";
};